// --- React & Redux
import React from "react";
import { useSelector } from "react-redux";
// --- Components
import { UploadJobTasksList } from "tap/components/UploadJobTasksList";

/**
 * Lists invalid/error tasks from the last offers upload job.
 */
export function OffersUploadTasksForm() {
  const { offersUploadJobTasks } = useSelector((state) => state.offers);

  return <UploadJobTasksList tasks={offersUploadJobTasks} />;
}
